/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AllevatoreDTO } from './AllevatoreDTO';
import {
    AllevatoreDTOFromJSON,
    AllevatoreDTOFromJSONTyped,
    AllevatoreDTOToJSON,
} from './AllevatoreDTO';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';
import type { CaricoMezzoDTO } from './CaricoMezzoDTO';
import {
    CaricoMezzoDTOFromJSON,
    CaricoMezzoDTOFromJSONTyped,
    CaricoMezzoDTOToJSON,
} from './CaricoMezzoDTO';
import type { CaricoOraDTO } from './CaricoOraDTO';
import {
    CaricoOraDTOFromJSON,
    CaricoOraDTOFromJSONTyped,
    CaricoOraDTOToJSON,
} from './CaricoOraDTO';

/**
 * 
 * @export
 * @interface AllevamentoDTO
 */
export interface AllevamentoDTO {
    /**
     * 
     * @type {number}
     * @memberof AllevamentoDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    idNazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllevamentoDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof AllevamentoDTO
     */
    banca?: BancaDTO;
    /**
     * 
     * @type {number}
     * @memberof AllevamentoDTO
     */
    idAllevatore?: number;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    codiceAllevamento?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    descrizioneBreve?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    personaRiferimento?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AllevamentoDTO
     */
    idTecnico?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AllevamentoDTO
     */
    caricoGiorno?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    maxCaricoGiorno?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AllevamentoDTO
     */
    minutiTrasferimento?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    pesa?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    incompatibile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AllevamentoDTO
     */
    note?: string | null;
    /**
     * 
     * @type {CaricoOraDTO}
     * @memberof AllevamentoDTO
     */
    caricoOra?: CaricoOraDTO;
    /**
     * 
     * @type {CaricoMezzoDTO}
     * @memberof AllevamentoDTO
     */
    caricoMezzo?: CaricoMezzoDTO;
    /**
     * 
     * @type {AllevatoreDTO}
     * @memberof AllevamentoDTO
     */
    allevatore?: AllevatoreDTO;
}

/**
 * Check if a given object implements the AllevamentoDTO interface.
 */
export function instanceOfAllevamentoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AllevamentoDTOFromJSON(json: any): AllevamentoDTO {
    return AllevamentoDTOFromJSONTyped(json, false);
}

export function AllevamentoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllevamentoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': !exists(json, 'idNazione') ? undefined : json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
        'idAllevatore': !exists(json, 'idAllevatore') ? undefined : json['idAllevatore'],
        'codiceAllevamento': !exists(json, 'codiceAllevamento') ? undefined : json['codiceAllevamento'],
        'descrizioneBreve': !exists(json, 'descrizioneBreve') ? undefined : json['descrizioneBreve'],
        'personaRiferimento': !exists(json, 'personaRiferimento') ? undefined : json['personaRiferimento'],
        'idTecnico': !exists(json, 'idTecnico') ? undefined : json['idTecnico'],
        'caricoGiorno': !exists(json, 'caricoGiorno') ? undefined : json['caricoGiorno'],
        'maxCaricoGiorno': !exists(json, 'maxCaricoGiorno') ? undefined : json['maxCaricoGiorno'],
        'minutiTrasferimento': !exists(json, 'minutiTrasferimento') ? undefined : json['minutiTrasferimento'],
        'pesa': !exists(json, 'pesa') ? undefined : json['pesa'],
        'incompatibile': !exists(json, 'incompatibile') ? undefined : json['incompatibile'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'caricoOra': !exists(json, 'caricoOra') ? undefined : CaricoOraDTOFromJSON(json['caricoOra']),
        'caricoMezzo': !exists(json, 'caricoMezzo') ? undefined : CaricoMezzoDTOFromJSON(json['caricoMezzo']),
        'allevatore': !exists(json, 'allevatore') ? undefined : AllevatoreDTOFromJSON(json['allevatore']),
    };
}

export function AllevamentoDTOToJSON(value?: AllevamentoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
        'idAllevatore': value.idAllevatore,
        'codiceAllevamento': value.codiceAllevamento,
        'descrizioneBreve': value.descrizioneBreve,
        'personaRiferimento': value.personaRiferimento,
        'idTecnico': value.idTecnico,
        'caricoGiorno': value.caricoGiorno,
        'maxCaricoGiorno': value.maxCaricoGiorno,
        'minutiTrasferimento': value.minutiTrasferimento,
        'pesa': value.pesa,
        'incompatibile': value.incompatibile,
        'note': value.note,
        'caricoOra': CaricoOraDTOToJSON(value.caricoOra),
        'caricoMezzo': CaricoMezzoDTOToJSON(value.caricoMezzo),
        'allevatore': AllevatoreDTOToJSON(value.allevatore),
    };
}

